import React from 'react'

import HierForm from '../Components/HierForm/HierForm';

const BoxingformPage = () => {
  return (
    <div>

      <HierForm />
  
    </div>
  )
}

export default BoxingformPage
